<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="9.98" height="9.981" viewBox="0 0 9.98 9.981">
    <g transform="translate(0.707 0.707)">
      <path d="M9.066.5.5,9.066" transform="translate(-0.5 -0.5)" class="fill-current" stroke="#4f3da5" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
      <path d="M3.355.5.5,3.355" transform="translate(5.211 5.211)" fill="none" stroke="#4f3da5" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
    </g>
  </svg>
</template>
